module.exports = __webpack_public_path__ + "img/setting_1.a970b2bc.svg";